module.exports = __webpack_public_path__ + "static/media/info-image2.a4b780b0.svg";